import {dateTimeHelper} from "../Helpers/datetimeHelper.js"

export default class CalendarDay
{
    TimeFrameList = [];
    Date = null

    constructor(date, timeFrameList) 
    {
      this.Date = date;
      this.TimeFrameList = timeFrameList;
      this.divId = `div${dateTimeHelper.getFormattedDate(this.Date, '_')}`;

      for (let i = 0; i < this.TimeFrameList.length; i++) {
        this.TimeFrameList[i].DivId = `div_${dateTimeHelper.getFormattedDate(this.Date, '_')}_${
          this.TimeFrameList[i].StartTime
        }`;
      }
  }
}